import { useState } from "react";
import { VideoModal } from "./VideoModal";
import styles from "./VideoPreview.module.scss";

interface VideoPreviewProps {
	videoSrc: string;
	previewImage: string;
	title: string;
	isOpen?: boolean;
	onOpenChange?: (isOpen: boolean) => void;
}

export const VideoPreview = ({
	videoSrc,
	previewImage,
	title,
	isOpen: externalIsOpen,
	onOpenChange
}: VideoPreviewProps) => {
	const [internalIsOpen, setInternalIsOpen] = useState(false);

	const isOpen = externalIsOpen !== undefined ? externalIsOpen : internalIsOpen;

	const handleOpen = () => {
		const newValue = true;
		if (onOpenChange) {
			onOpenChange(newValue);
		}
		if (externalIsOpen === undefined) {
			setInternalIsOpen(newValue);
		}
	};

	const handleClose = () => {
		const newValue = false;
		if (onOpenChange) {
			onOpenChange(newValue);
		}
		if (externalIsOpen === undefined) {
			setInternalIsOpen(newValue);
		}
	};

	return (
		<>
			{isOpen == undefined && <div className={styles.previewContainer} onClick={handleOpen}>
				<img src={previewImage} alt={title} className={styles.previewImage} />
				<div className={styles.playOverlay}>
					{/* <PlayCircle size={64} className={styles.playIcon} /> */}
					<span className={styles.playText}>Смотреть видео-подсказку</span>
				</div>
			</div>}

			<VideoModal isOpen={isOpen} onClose={handleClose} videoSrc={videoSrc} />
		</>
	);
};